// extracted by mini-css-extract-plugin
export default {"root":"facebookPage_root__tkoZ0","fbLink":"facebookPage_fbLink__uIN8Z","postContainer":"facebookPage_postContainer__thaYC"};